/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './Loader.css'
import { LOADING } from '../../../global/Icons';

class Loader extends Component {

    constructor(props) {
        super(props)
        this.state = {
            message: this.props.message
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.message !== this.state.message) {
            this.setState({ message: this.props.message });
        }
    }

    _onOkClick = () => {
        if (this.props.onLoaderClose !== null) {
            this.props.onLoaderClose();
        }
    }

    _renderMessage = (message) => {
        if (message === undefined || message.length === 0) {
            return <img src={LOADING} alt="" />;
        }
        return (
            <div className="loading-error-msg">
                <span>{message}</span>
                <div className="mt-3 text-center">
                    <a className="btn btn-primary btn-sm" onClick={() => { this._onOkClick() }}>OK</a>
                </div>
            </div>
        )

    }


    render() {
        const { message } = this.state;
        return (
            <div className="loader-section">
                <div className="loader-content">
                    {this._renderMessage(message)}
                </div>
            </div>

        )

    }
}
export default Loader